import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  FormControlLabel,
  FormHelperText,
  Stack,
  Switch,
} from '@mui/material';
import { useId } from 'react';

import { Text, isDefined, isTruthy } from 'common';

import { useReactFlowViewContext } from '../../../../context/context';
import { BlockValueTemplateFieldArea } from '../../../ConfigFields/CodeMirror/FlowTemplate';
import { useSelectedNodeField } from '../../../ConfigFields/useSelectedNodeField';

const PRE_ASSISTANT_MESSAGE_HELPER_TEXT = `Enable to speak a message before connecting to the AI assistant.`;
const MESSAGE_HELPER_TEXT = `The message that will be spoken to the caller before connecting them to the AI assistant. The message itself, as well as anything the caller says before or during the message, will not be transcribed or recorded. Transcription and recording will start once the AI assistant is connected.`;

export function PreAssistantMessageFormFields(props: {
  expanded: boolean;
  onChange: (event: React.SyntheticEvent, isExpanded: boolean) => void;
}) {
  const { expanded, onChange } = props;
  const id = useId();

  const {
    value: preAssistantMessage,
    setValue,
    visibleError,
  } = useSelectedNodeField<string | undefined>('config.preAssistantMessage');
  const { isEditable } = useReactFlowViewContext();

  const isEnabled = isDefined(preAssistantMessage);
  const fieldId = useId();

  return (
    <Accordion variant="elevation" expanded={expanded} onChange={onChange}>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        id={id}
        aria-controls="pre-assistant-message-content"
      >
        <Text variant="heading5">Pre-assistant message</Text>
      </AccordionSummary>
      <AccordionDetails sx={{ gap: 2 }}>
        <Stack spacing={2}>
          <FormControlLabel
            control={
              <Switch
                id={fieldId}
                checked={isEnabled}
                onChange={() => {
                  if (isEnabled) {
                    setValue(undefined);
                  } else {
                    setValue('');
                  }
                }}
                disabled={!isEditable}
              />
            }
            label="Enable pre-assistant message"
          />
          <FormHelperText>{PRE_ASSISTANT_MESSAGE_HELPER_TEXT}</FormHelperText>
          {visibleError && (
            <FormHelperText error={isTruthy(visibleError)}>{visibleError}</FormHelperText>
          )}
          {isEnabled && (
            <BlockValueTemplateFieldArea
              fieldName="config.preAssistantMessage"
              label="Pre-assistant message"
              helperText={MESSAGE_HELPER_TEXT}
              placeholder="Enter the message to speak before connecting to the assistant..."
            />
          )}
        </Stack>
      </AccordionDetails>
    </Accordion>
  );
}
